import React, { Component } from 'react';
import Prismic from 'prismic-javascript';
import { isEmpty } from 'lodash';
import withDataConsumer from './contextApi/withDataConsumer';

function withDataFetch(WrappedComponent, documentType) {
  return withDataConsumer(class extends Component {
    state = {}

    componentWillMount() {
      const { context: { dataStore, handleDataStoreChange } } = this.props;
      if (!dataStore[documentType]) {
        this.setState({ isLoading: true });
      }
      Prismic.api('https://jtvsuriname.prismic.io/api/v2')
        .then(api => {
          api
            .query(
              [Prismic.Predicates.at('document.type', documentType)],
            )
            .then((response) => {
              const { results } = response;

              if (isEmpty(results)) {
                throw new Error(`Geen data beschikbaar voor type: ${documentType}.`);
              }

              const { 0: { data, type, id }, version } = results;

              dataStore[documentType] = {
                data,
                type,
                version,
                id,
              };
              handleDataStoreChange(dataStore);

              this.setState({
                isLoading: false,
              });
            })
            .catch(({ message }) => {
              this.setState({
                error: message,
              });
            });
        });
    }

    render() {
      const { context: {
        dataStore: {
          [documentType]: { data, id } = {},
        },
      },
      } = this.props;
      const { isLoading, error } = this.state;
      return (
        <WrappedComponent
          docId={id}
          data={data}
          isLoading={isLoading}
          error={error}
          {...this.props}
        />
      );
    }
  });
}

export default withDataFetch;



// WEBPACK FOOTER //
// ./src/api/withDataFetch.js